import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from '../constants/translations/en.json';

const initializeI18next = (): void => {
  i18n.use(initReactI18next).init({
    resources: {
      en
    },
    lng: 'en',
    fallbackLng: 'en',
    nsSeparator: false,
    keySeparator: false,
    interpolation: {
      escapeValue: false
    }
  });
};

export default initializeI18next;
